import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
const comparisons = [{
  without: '120 horas al año planificando desde cero',
  withPack: '5 minutos por sesión. El resto es entrenar.'
}, {
  without: '60% de abandono antes del año',
  withPack: 'Sistema de retención → +88% se queda'
}, {
  without: 'Los padres no ven progreso → se van',
  withPack: 'Informe mensual → confían y renuevan'
}, {
  without: 'Precio indefinido → cobrás de menos',
  withPack: 'Fórmula de precio exacta → rentabilidad real'
}];
export function FinalCTA() {
  return <section className="w-full bg-[#111111] py-16 sm:py-24 px-4 overflow-hidden" data-id="element-82">
      <div className="max-w-2xl mx-auto text-center relative" data-id="element-83">
        {/* Ambient glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#22C55E]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-84" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} className="relative z-10" data-id="element-85">
          <div className="text-[#22C55E]/70 text-xs font-bold tracking-[0.3em] uppercase mb-5" data-id="element-86">
            ⚽ MEGAPACK FÚTBOL LISTO™
          </div>

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-2 leading-tight" data-id="element-87">
            Seguir improvisando o{' '}
            <span className="text-[#22C55E]" data-id="element-88">
              tener todo resuelto desde hoy.
            </span>
          </h2>
          <p className="text-gray-400 text-sm sm:text-base mb-8 sm:mb-10" data-id="element-89">
            Vos elegís.
          </p>

          {/* Compact Cost Table */}
          <div className="bg-white/[0.02] border border-[#22C55E]/20 rounded-2xl overflow-hidden mb-10 shadow-xl text-left" data-id="element-90">
            <div className="p-3 sm:p-4 bg-black/60 border-b border-[#22C55E]/30 text-center font-bold text-white text-xs sm:text-sm" data-id="element-91">
              ¿Cuánto cuesta NO tenerlo?
            </div>
            {comparisons.map((row, i) => <div key={i} className="grid grid-cols-1 sm:grid-cols-2 border-b border-white/5 last:border-b-0" data-id="element-92">
                <div className="p-3 sm:p-4 text-gray-400 text-xs sm:text-sm flex items-center" data-id="element-93">
                  ❌ {row.without}
                </div>
                <div className="p-3 sm:p-4 text-white font-bold text-xs sm:text-sm bg-[#22C55E]/[0.03] sm:border-l border-white/5 flex items-center" data-id="element-94">
                  ✅ {row.withPack}
                </div>
              </div>)}
          </div>

          {/* Countdown */}
          <div className="mb-5" data-id="element-95">
            <p className="text-white font-bold text-sm sm:text-base mb-4" data-id="element-96">
              ⏰ El precio de lanzamiento cierra en:
            </p>
            <CountdownTimer size="lg" blinking={true} data-id="element-97" />
          </div>
          <p className="text-gray-400 text-xs sm:text-sm mb-8" data-id="element-98">
            Después sube y no vuelve.
          </p>

          {/* 2 mini pricing cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5 mb-8" data-id="element-99">
            <motion.div whileHover={{
            y: -4
          }} className="bg-[#1a1a1a] border border-white/10 rounded-2xl p-5 sm:p-6 text-center flex flex-col transition-colors hover:border-white/20" data-id="element-100">
              <div className="text-2xl mb-2" data-id="element-101">📘</div>
              <h3 className="text-white font-black text-sm sm:text-base mb-1" data-id="element-102">
                MEGAPACK FÚTBOL LISTO
              </h3>
              <p className="text-gray-400 text-[11px] sm:text-xs mb-4" data-id="element-103">
                6 Tomos + 6 Bonos
              </p>
              <div className="mt-auto" data-id="element-104">
                <p className="text-white text-2xl sm:text-3xl font-black mb-3" data-id="element-105">
                  $13,90{' '}
                  <span className="text-sm text-gray-400 font-bold" data-id="element-106">USD</span>
                </p>
                <motion.a href="https://docentes2.edulabs.online/cart/43285137457270:1" whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="btn-green-pulse block bg-[#22C55E] text-black font-black py-3.5 sm:py-4 rounded-xl hover:bg-[#4ADE80] transition-colors text-xs sm:text-sm shadow-lg" data-id="element-107">
                  SÍ, QUIERO MI MEGAPACK →
                </motion.a>
              </div>
            </motion.div>

            <motion.div whileHover={{
            y: -4
          }} className="relative bg-[#052e16] border-2 border-[#22C55E] rounded-2xl p-5 sm:p-6 text-center shadow-[0_0_30px_rgba(34,197,94,0.15)] flex flex-col" data-id="element-108">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#22C55E] to-[#16A34A] text-black text-[9px] sm:text-[10px] font-black px-3 py-0.5 rounded-full whitespace-nowrap" data-id="element-109">
                ⭐ MÁS ELEGIDO
              </div>
              <div className="text-2xl mb-2 mt-1" data-id="element-110">🏆</div>
              <h3 className="text-[#22C55E] font-black text-sm sm:text-base mb-1 leading-tight" data-id="element-111">
                MEGAPACK + ÉLITE 360
              </h3>
              <p className="text-gray-400 text-[11px] sm:text-xs mb-4 leading-tight" data-id="element-112">
                Todo + sistema de gestión y escala
              </p>
              <div className="mt-auto" data-id="element-113">
                <p className="text-[#22C55E] text-2xl sm:text-3xl font-black mb-3" data-id="element-114">
                  $19,90{' '}
                  <span className="text-sm text-gray-400 font-bold" data-id="element-115">USD</span>
                </p>
                <motion.a href="https://docentes2.edulabs.online/cart/43285137490038:1" whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="btn-green-pulse green-shimmer block bg-[#22C55E] text-black font-black py-3.5 sm:py-4 rounded-xl hover:bg-[#4ADE80] transition-colors text-xs sm:text-sm shadow-[0_0_20px_rgba(34,197,94,0.3)]" data-id="element-116">
                  SÍ, QUIERO EL PACK COMPLETO →
                </motion.a>
              </div>
            </motion.div>
          </div>

          {/* Local currency + trust */}
          <p className="text-gray-300 text-[11px] sm:text-sm font-medium text-center mb-6" data-id="element-117">
            <span className="inline-flex items-center align-middle mr-1 text-sm leading-none" data-id="element-118">
              🌎
            </span>
            Pagás en <strong className="text-white" data-id="element-119">tu moneda local</strong> —
            el monto se convierte automáticamente
          </p>

          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-120">
            {[{
            icon: '🔒',
            text: 'Pago seguro'
          }, {
            icon: '⚡',
            text: 'Acceso en 5 min'
          }, {
            icon: '🛡️',
            text: 'Garantía 7 días'
          }, {
            icon: '💳',
            text: 'Tarjeta · PayPal · Transferencia'
          }].map((badge, i) => <div key={i} className="flex items-center gap-1.5 bg-white/[0.03] border border-white/[0.05] rounded-lg px-3 py-2" data-id="element-121">
                <span className="text-sm" data-id="element-122">{badge.icon}</span>
                <span className="text-gray-300 text-[10px] sm:text-xs font-medium" data-id="element-123">
                  {badge.text}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}